var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"breadcrumb-separator",attrs:{"aria-hidden":"true"}},[_c('v-icon',[_vm._v("mdi-slash-forward")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }